import React from 'react';
import '../App.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p className="copyright">
          &copy; 2024 All Rights Reserved by <a href="#" className="copyright-link">léyaa.Hub</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
